import { render, staticRenderFns } from "./MortgageYN.vue?vue&type=template&id=3a2946d6"
import script from "./MortgageYN.vue?vue&type=script&lang=js"
export * from "./MortgageYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports